import React from 'react';

import ImageLazy from '@common/react/components/UI/ImageLazy/ImageLazy';

import Background from '@app/components/UI/Background/Background';
import Card from '@app/components/UI/Card/Card';
import HelmetProvider from '@app/components/UI/Helmet/HelmetCustom';
import SelectedText from '@app/components/UI/SelectedText';
import '@app/scss/pages/about.scss';

const About: React.FC = () => {
	return (
		<HelmetProvider title="About">
			<div className="about-page pages">
				<Background />
				<div className="about-first-screen">
					<div className="container">
						<Card
							image={
								<>
									<h2>
										<SelectedText text="About Dr. " />
										Mary Gardner
									</h2>
									<h3>Veterinarian, innovator, professional speaker</h3>
									<p className="h4">
										A dynamic and engaging keynote speaker, Dr. Mary Gardner is able to draw on a wide range of career
										experiences and life lessons to educate and motivate diverse audiences. Her presentations cover a
										variety of topics, and encourage both professional and personal growth within the veterinary industry
										and beyond. Ironically, veterinary medicine was not her first career choice.
									</p>
								</>
							}
							text={
								<>
									<div className="h2">2022</div>
									<p className="h4">Published 6 books for senior pets</p>
									<div className="h2">2020</div>
									<p className="h4">VMX Speaker of the Year for Small Animal Medicine</p>
									<div className="h2">2018</div>
									<p className="h4">Was voted the veterinarian to watch in 2018 by Fetch/DVM360</p>
									<div className="h2">2016</div>
									<p className="h4">Alumni Achievement Award from the University of Florida</p>
									<div className="h2">2008</div>
									<p className="h4">Doctorate of Veterinary Medicine from the University of Florida</p>
									<picture>
										<source media="(max-width: 1100px)" srcSet="/images/doctormarymay-m.png" />
										<source media="(min-width: 1101px)" srcSet="/images/doctormarymay.png" />
										<img className="about-first-screen-img" srcSet="/images/doctormarymay.png" />
									</picture>
								</>
							}
						/>
					</div>
				</div>
				<div className="bg-white-opacity second-block">
					<div className="container">
						<Card
							image={
								<>
									<ImageLazy height={482} width={516} src="/images/Group 60.png" />
									<svg
										className="arrow"
										xmlns="http://www.w3.org/2000/svg"
										width="105"
										height="89"
										viewBox="0 0 105 89"
										fill="none"
									>
										<path
											d="M0.775217 80.136C5.40553 78.5707 10.0708 77.3196 14.8689 76.4038C14.9667 76.4248 14.9876 76.327 15.0854
						76.3479C16.147 76.1662 16.3218 77.7376 15.4349 78.059C12.2782 79.4285 9.14252 80.7002 5.98585 82.0697C20.765
						84.2112 36.4311 86.0314 50.3987 80.0224C64.4849 73.9366 72.9546 61.1259 71.0173 46.2915C58.5291 44.4359 46.7171
						36.0778 40.3875 25.5187C37.8374 21.1889 34.5462 12.2007 42.2706 10.991C49.5621 9.89319 57.8609 18.4195 62.1292
						23.3217C67.3825 29.3553 71.1833 36.9186 72.5885 44.6849C73.4895 44.7755 74.4883 44.8871 75.4102 44.8799C83.6238
						45.2067 92.8426 42.2717 96.5778 34.3788C101.381 24.3624 100.301 12.8324 97.4266 2.34496C97.1192 1.87008 112.328
						-0.58883 98.1389 1.88389C102.817 13.2596 101.265 25.3248 100.41 29.8581C98.8885 37.9183 91.1317 44.053 83.4004
						45.7725C79.9573 46.5693 76.3464 46.7166 72.8402 46.375C74.0361 55.1191 72.1519 63.9197 65.7975 71.1496C50.917
						88.1101 27.184 86.7105 6.72651 83.8645L11.1551 87.0626C12.1261 87.7818 10.8342 89.0392 9.96105 88.3409C7.66989
						86.6232 5.3578 85.0032 2.96886 83.2646C2.87108 83.2436 2.77327 83.2227 2.5777 83.1808C2.18656 83.0971 1.93509
						82.8387 1.90012 82.5244C1.45307 82.2242 0.92917 81.8052 0.482121 81.5049C-0.181429 81.2606 0.125707 80.3037
						0.775217 80.136ZM69.9478 41.256C67.8303 33.9508 63.5477 27.2048 58.1479 21.8558C55.4584 19.1324 52.3151 16.6186
						48.9483 14.6705C47.5862 13.8676 46.1054 13.1415 44.6177 12.9253C39.9591 12.2346 38.4721 16.3137 39.6951
						20.1549C43.5457 32.7399 57.7744 42.229 70.7865 44.5036C70.507 43.4211 70.2274 42.3386 69.9478 41.256Z"
											fill="#5D4493"
										/>
									</svg>
								</>
							}
							text={
								<>
									<h2>
										<SelectedText text="The path " />
										to veterinary medicine
									</h2>
									<p className="h4">
										After graduating from the University of Miami, she began working as a Technical Business Architect for
										an order and supply chain management software company. Her innate talent for understanding logistics
										in a client-centric organization developed a unique skill set for a veterinarian. After 10 years in
										software, she found herself longing for something different and more meaningful — the path she
										selected was to become a veterinarian.
									</p>
								</>
							}
						/>
						<Card
							imageLeftSide={false}
							image={<ImageLazy height={661} width={653} src="/images/about-secon-screen.png" />}
							text={
								<>
									<p className="h4">
										After spending two years in general practice, Dr Mary felt she wasn’t making the impact she wanted for
										pets and their families. She became a co-founder in Lap of Love Veterinary Hospice, which offers end
										of-life services for pets in the comfort of their own home. The company went from one veterinarian in
										Tampa to hundreds of veterinarians around the country.
									</p>
									<p className="h4">
										Dr. Mary leads development for Lap of Love’s proprietary web-based practice management software called
										Sunshine. The program is specifically designed for veterinary hospice and euthanasia services and also
										dynamically ties to the Lap of Love website to allow families the ability to locate the veterinarian
										closest to them.
									</p>
								</>
							}
						/>
					</div>
				</div>
				<div className="about-last-block">
					<div className="container">
						<Card
							image={
								<iframe
									title="youtube-iframe-about"
									src="https://www.youtube.com/embed/mqPfE0isQjE?si=aHR-nCsCA24HNo3y&amp;controls=0"
								/>
							}
							text={
								<div className="card-text__inner">
									<h3>
										In 2018, Dr. Mary embarked on a heartfelt mission to address a profound need within the community,
										leading to the establishment of Monarch, a pet crematory in South Florida. Recognizing the importance
										of offering families a compassionate and caring solution for their beloved pets' aftercare, Monarch
										specializes in aquamation, an environmentally sensitive process. With a resolute commitment to their
										mission, the team at Monarch is dedicated to helping families honor the lives of those they love,
										providing a dignified and environmentally conscious pet aftercare service that South Florida residents
										can trust and rely on.
									</h3>
									<ImageLazy src="/images/cat-green.png" alt="cat green background" width={441} height={368} />
								</div>
							}
						/>
					</div>
				</div>
			</div>
		</HelmetProvider>
	);
};

export default About;
